<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">
			<top-nevleft></top-nevleft>
			
		 <b-col > 
			<!-- <b-row class="breadcrumbrow mt-1 m-0">				
				<b-col>
				 <h5 class="text-center">Seller Dashboard</h5>
				</b-col>				
			</b-row> -->
		
		<b-container fluid class="p-0 mt-2">
		
					<b-row class="mt-3 mb-2 m-0">
						<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
							<!--<h3>Manage Brands</h3> -->
						</b-col>
						<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
							<b-button variant="dark" pill class="mr-2" @click="showAddModal()"  size="sm"><b-icon class="mr-2" icon="plus" aria-hidden="true" ></b-icon>Add Videos</b-button>
							
						</b-col>
					</b-row>
				<b-container fluid class="my-2">
				<b-row class="m-0">
					<b-col class="col-md-12 col-sm-12 col-xs-12">
						<div class="container-box">
							<b-row class="mt-4 px-3">
								<b-col lg="6" class="text-left">
									<span class="mr-2">Show</span>
									<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
									</b-form-select>
									<span class="ml-2">entries</span>
								</b-col>
								<b-col lg="4" offset-md="2">
									<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
										<b-input-group size="sm">
											<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
											</b-form-input>
											<b-input-group-append>
												<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
											</b-input-group-append>
										</b-input-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="px-3 pt-3">
								<b-col lg="12">
									<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
										
										<!--<template v-slot:cell(actions)="row">
											<b-button pill variant="primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button>
											<b-button pill variant="danger" class="mr-1 icon-btn" @click="showDeleteModal(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
										</template> -->
										<template v-slot:cell(status)="row">
											<b-badge pill variant="warning" v-if="row.value == 0">In Active</b-badge>
											<b-badge pill variant="success" v-else>Active</b-badge>										
										</template>
										<template v-slot:cell(video_url)="row">
											<!--<b-img v-bind="thumbnailProps" rounded alt="" v-if="row.value==''" :src="$root.MEDIAPATH+'blank.jpg'">{{row}}</b-img> -->
											<b-link>{{row.item.video_url}}</b-link>
										</template>
										<template v-slot:cell(actions)="row">
											<!--<b-button pill variant="outline-primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button> -->
											<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="showDeleteModal(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
										</template>
									</b-table>
								</b-col>
							</b-row>
							<b-row class="px-3">
								<b-col lg="6" class="text-left">
									<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
								</b-col>
								<b-col lg="3" offset-md="3">
									<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
								</b-col>
							</b-row>
						</div>
					</b-col>
				</b-row>
				
				
			</b-container>

				
		
			
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
			<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
	
	<video-add  :filteredCategory="filteredCategory" :brandlist="brandlist" :sizelist="sizelist" :category="category" ></video-add>
	</div>
	
</template>
<script>
import '@/assets/profileuser.scss';
//import Header from "@/components/seller/Header.vue";
import Header from "@/components/header.vue";
import TreeviewPage from "@/components/seller/nevleft.vue";
import Footer from "@/components/footer-admin.vue";
import Videoadd from "@/components/video-add";

export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"video-add": Videoadd,
		
	},
	mounted(){
		//var self = this;
		//Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            product_inf: {},
			brandlist: [],
			sizelist: [],
			brandlist3:[],
			
		
			/*product_glb: '',*/
			model_maps: {},
			//recordUrl: this.$root.WEBAPI+'sellerapi/brand-record',
			recordUrl: this.$root.WEBAPI+'sellerapi/video-record',
			getBrandByIdUrl: this.$root.WEBAPI+'secureapi/getBrandById',
			//insertUrl: this.$root.WEBAPI+'sellerapi/brand-insert',
			//insertUrl: this.$root.NEWAPIURL+'sellerapi/brand-insert',
			//updateUrl: this.$root.NEWAPIURL+'sellerapi/brandupdate',
			//deleteUrl: this.$root.WEBAPI+'sellerapi/brand-delete',
			deleteUrl: this.$root.WEBAPI+'sellerapi/video-delete',
			//csvgenUrl: this.$root.WEBAPI+'sellerapi/product-csvgen',
			filteredCategory: [],
			category: [],
			records: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Brands',
					active: true
				}
			],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'title', label: 'Title'},				
				{ key: 'video_url', label: 'Video'},
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: 'id',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {
				brand_name: '',
				about_brand: '',
				status: '',
				short_description: '',
				product_data:{}, 
				tier_price:[], 
				gallery_images:[""]
			},
			selectedItemState: {
				brand_name:null,
				about_brand:null,
				status:null,
			},
			emptyItem: {
				id: 0,
				brand_name: '',
				about_brand: '',
				brand_logo: '',
				gallery_images:[""],
                status: 0
			},
			counterindex:1
		};
	},
	methods: {		
		showAddModal(){
		
		
			/* Get Brand List By Product User ID*/
			//console.log(this.$session.get('customer_info').username+'----'+this.$session.get('customer_info').user_id);
			
			
		
		
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		/*showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			if(item.product_data){
				this.selectedItem.product_data = JSON.parse(item.product_data);
			}
			if(item.tier_price){
				this.selectedItem.tier_price = JSON.parse(item.tier_price);
			}
			
			this.$root.$emit('bv::show::modal', 'my-model', button)
		},*/
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Video!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.products;
					//console.log(self.records);
					self.category = response.data.result.category; 
					self.loading = false;
					self.totalRows = self.records.length;

					self.filteredCategory = [];
					self.filterChildCategory(0, 0, 0);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			
			//var self =this;
			var productUserId = self.$session.get('customer_info').user_id;
			//accesskey: self.$session.get('access_key')
			self.axios.post(self.getBrandByIdUrl, {
				accesskey: self.$session.get('access_key'),
				user_id:productUserId
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//console.log('ddd'+response.data.result);
					self.brandlist = response.data.result.brandlist;
					self.sizelist = response.data.result.sizelist;
					//this.brandlist = response.data.result;
					//self.brandlist =response.data.result;
					
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
		
			
			
			
			//alert('login '+self.email+" "+self.password);
		},
		filterChildCategory(id, index, parentid){
			var self = this;
			var tab = '';
			for (let i = 0; i < index; i++) {
				tab += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
			}
			this.category.forEach(function(field){
				if(field.parent == id){
					var fieldid = field.id;
					if(parentid != 0){
						fieldid = parentid+','+field.id;
					}
					self.filteredCategory.push({ html: tab+field.title, title:field.title, position:field.position, parent:field.parent, value: fieldid });
					
					//self.optionsSel.push({ name: tab+field.title, language:field.title,value: fieldid});
					
					self.filterChildCategory(field.id, index+1, fieldid);
				}
			});
			return ;
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
	}
}
</script>
<style>
</style>